import _ from 'lodash'
import { useEffectOnce } from 'react-use'
import ProgramNutritionTable from './table'
import { useLocation } from 'react-router-dom'
import ProgramNutritionToolBar from './toolbar'
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { getWorkoutChapterList } from 'api/WorkoutChapter'

export default function (props) {
  const ref = useRef()
  const location = useLocation()
  const [workoutChapters, setWorkoutChapters] = useState({})
  const [params, setParams] = useState({ page: 1, filters: {} })

  // start
  useEffectOnce(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    setParams({ page: 1, ...too })
  })

  const loadData = useCallback(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    getWorkoutChapterList(too).then(resp => setWorkoutChapters(resp))
  }, [location.search])

  // load data
  useEffect(() => {
    loadData()
  }, [loadData])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const foo = Object.fromEntries(new URLSearchParams(location.search))
    const too = _.pickBy({ ...foo, page: 1, ...payload }, _.identity)
    setParams(too)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(too)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }
  // end

  return (
    <div className={'root'}>
      <ProgramNutritionToolBar {...props} params={params} onParamsChange={handleParamsChange} />
      <div className={'content'}>
        <ProgramNutritionTable {...props} data={workoutChapters} page={params.page} onPageChange={handlePageChange} />
      </div>
    </div>
  )
}
